import _extends from "@babel/runtime/helpers/esm/extends";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import PropTypes from 'prop-types';
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { is8pxTheme } from "../../../lib/theming/ThemeHelpers";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
/**
 * Контейнер, расстояние между элементами в котором равно `gap`.
 */

export var Gapped = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Gapped, _React$Component);

  function Gapped() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.theme = void 0;
    return _this;
  }

  var _proto = Gapped.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this2.theme = theme;
      return /*#__PURE__*/React.createElement(CommonWrapper, _this2.props, _this2.props.vertical ? _this2.renderVertical() : _this2.renderHorizontal());
    });
  };

  _proto.getGapValue = function getGapValue() {
    // DEPRECATED remove in 4.0
    var propsGap = this.props.gap;

    if (propsGap !== undefined && propsGap !== null) {
      return propsGap;
    } else {
      var gap = is8pxTheme(this.theme) ? 8 : 10;
      return gap;
    }
  };

  _proto.renderVertical = function renderVertical() {
    var subsequentItemStyle = {
      paddingTop: this.getGapValue()
    };
    var isFirst = true;
    var children = React.Children.map(this.props.children, function (child) {
      if (!child) {
        return child;
      }

      var style = isFirst ? undefined : subsequentItemStyle;
      isFirst = false;
      return /*#__PURE__*/React.createElement("div", {
        style: style
      }, child);
    });
    return /*#__PURE__*/React.createElement("div", null, children);
  };

  _proto.renderHorizontal = function renderHorizontal() {
    var _this$props = this.props,
        children = _this$props.children,
        verticalAlign = _this$props.verticalAlign,
        wrap = _this$props.wrap;
    var gap = this.getGapValue();

    var itemStyle = _extends({
      display: 'inline-block',
      verticalAlign: verticalAlign
    }, wrap ? {
      marginLeft: gap,
      marginTop: gap
    } : {});

    var rootStyle = wrap ? {
      paddingTop: 1
    } : {};
    var contStyle = wrap ? {
      marginTop: -gap - 1,
      marginLeft: -gap
    } : {
      whiteSpace: 'nowrap'
    };
    return /*#__PURE__*/React.createElement("div", {
      style: rootStyle
    }, /*#__PURE__*/React.createElement("div", {
      style: contStyle
    }, React.Children.toArray(children).map(function (child, index) {
      var marginLeft = index === 0 ? undefined : gap;
      return /*#__PURE__*/React.createElement("span", {
        key: index,
        style: _extends({
          marginLeft: marginLeft
        }, itemStyle)
      }, child);
    })));
  };

  return Gapped;
}(React.Component);
Gapped.__KONTUR_REACT_UI__ = 'Gapped';
Gapped.propTypes = {
  /**
  * Расстояние между элементами.
  */
  gap: PropTypes.number,

  /**
  * Располагать элементы вертикально.
  */
  vertical: PropTypes.bool,

  /**
  * Вертикальное выравнивание элементов.
  */
  verticalAlign: PropTypes.oneOf(['top', 'middle', 'baseline', 'bottom'])
};
Gapped.defaultProps = {
  wrap: false,
  vertical: false,
  verticalAlign: 'baseline'
};